import React, { useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import './CustomDropdown.css';
import { FaChevronDown } from 'react-icons/fa';

const CustomDropdown = ({
    value,
    options,
    onChange,
    className = '',
    placeholder = "Select",
    renderLabel,
    headerLabel,
    footerMessage
}) => {
    const selectedOption = options?.find(opt => opt.value === value);

    const displayLabel = renderLabel
        ? renderLabel(value, selectedOption)
        : selectedOption?.label || placeholder;

    const handleSelect = (optionValue, optionLabel = "") => {
        onChange(optionValue, optionLabel);
    };

    return (
        <Dropdown drop="down" className="custom-table-dropdown">
            <Dropdown.Toggle 
                variant="light" 
                size="sm" 
                className={className}
                // className={`dropdown-toggle-pill ${className}`}
            >
                {displayLabel}

                <FaChevronDown className="dropdown-icon" />
            </Dropdown.Toggle>

            <Dropdown.Menu 
                // container={document.body}
                renderOnMount
                popperConfig={{
                    strategy: 'fixed',
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: ['bottom'],
                            },
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: 'viewport',
                            },
                        },
                    ],
                }}
                className={`custom-dropdown-menu`}
            >
                {/* Header */}
                {
                    headerLabel && (
                        <div className="custom-dropdown-header">
                            {headerLabel}
                        </div>
                    )
                }

                {
                    options?.length > 0 ? (
                        options?.map(opt => (
                            <Dropdown.Item
                                key={opt.value}
                                onClick={() => handleSelect(opt.value, opt.label)}
                                // disabled={opt?.disabled}
                                disabled={opt?.value === value}
                                className="custom-dropdown-item"
                            >
                                {/* {opt.label} */}
                                {
                                    <div className="item-option">
                                        <div className="item-title">
                                            {opt.label}
                                        </div>
                                        {opt.description && (
                                            <div className="item-subtitle">
                                                {opt.description}
                                            </div>
                                        )}
                                    </div>
                                }
                            </Dropdown.Item>
                        ))
                    ) : (
                        <Dropdown.Item 
                            className="custom-dropdown-item"
                            disabled
                        >
                            Officer not listed? Please add officer to this branch via User Management.
                        </Dropdown.Item>
                    )
                }

                {/* Footer */}
                {
                    footerMessage && (
                        <div className="custom-dropdown-footer">
                            {footerMessage}
                        </div>
                    )
                }
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default CustomDropdown;